import Vue from "vue";
import i18next from "i18next";
import VueI18Next from "@panter/vue-i18next";

Vue.use(VueI18Next);

import localeEnTranslation from "../lang/en/front/translation";
import localeEnCountries from "../lang/en/front/countries";
import localeEnLanguages from "../lang/en/front/languages";
import localeEnOrganization from "../lang/en/front/organization";
import localeEnSubscriptions from "../lang/en/front/subscriptions";
import localeEnTeam from "../lang/en/front/team";
import localeEnUser from "../lang/en/front/user";

i18next.init({
  lng: "en",
  fallbackLng: "en",
  resources: {
    en: {
      countries: localeEnCountries,
      languages: localeEnLanguages,
      organization: localeEnOrganization,
      subscriptions: localeEnSubscriptions,
      team: localeEnTeam,
      translation: localeEnTranslation,
      user: localeEnUser,
    },
  },
  ns: ["countries", "languages", "organization", "team", "translation", "user"],
  defaultNS: "translation",
});

export default new VueI18Next(i18next);
